var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"codeEditor",staticClass:"codeEditor rounded",class:`${_vm.requiredCSS} ${_vm.languageCSS} ${_vm.resizeBehaviorCSS} ${_vm.themeCSS}`,style:(`min-height: ${_vm.minHeight}px;`)})
}
var staticRenderFns = []

export { render, staticRenderFns }